import PublicMessage, { type PublicMessageType } from "./PublicMessage";

type GenericMessageProps = {
  title: string;
  message: string;
  type: Exclude<PublicMessageType, "success">;
};

export default function GenericMessage({
  title,
  message,
  type,
}: GenericMessageProps) {
  return <PublicMessage title={title} message={message} type={type} />;
}
